"use client";

import { Box, Heading, Link, Stack, Text } from "@biblioteksentralen/react";
import { LCWork, LCWorkParams, VocabularyFacet, VocabularyFactor, VocabularyTerm } from "@libry-content/integrations";
import { DefaultContainer } from "../../../../../../../components/ContentContainer";
import { useSitePalette } from "../../../../../../../utils/useSitePalette";
import { DefaultPageLayout } from "../../../../../../../components/layout/DefaultPageLayout";
import { useTranslation } from "../../../../../../../utils/hooks/useTranslation";
import ItemGrid from "../../../../../../../searchAndCollection/components/works/ItemGrid";

type Props = {
  term?: VocabularyTerm;
  facet?: VocabularyFacet;
  factor?: VocabularyFactor;
  readalikeWorksParams?: LCWorkParams[];
};

const AppealTermClientSide = ({ term, factor, readalikeWorksParams }: Props) => {
  const palette = useSitePalette();
  const { t } = useTranslation();
  return (
    <DefaultPageLayout>
      <DefaultContainer>
        <Stack spacing="2rem">
          <Stack {...palette.colors.card.css} padding="2rem" spacing="1rem" borderRadius="lg">
            <Box>
              <Text fontWeight={600}>{factor?.name}</Text>
              <Heading as="h1">{term?.name}</Heading>
            </Box>
            <Text maxWidth="30rem">{term?.definition}</Text>
            <Text fontStyle="italic">
              {t("Hentet fra")} <Link href="https://forrigebok.no/info/om-forrigebok">{"Forrigebok.no"}</Link>
            </Text>
          </Stack>
          {/* Wrap Box around SimpleGrid to fix overflow bug in Safari */}
          {readalikeWorksParams && (
            <Box>
              <ItemGrid items={readalikeWorksParams.map((params) => new LCWork(params))} />
            </Box>
          )}
        </Stack>
      </DefaultContainer>
    </DefaultPageLayout>
  );
};

export default AppealTermClientSide;
